import React, { useEffect } from "react";
import moment from "moment";
import Modal from "../../Common/Modal";
import { useDispatch, useSelector } from "react-redux";

import editIcon from "../../../images/icons/svg/pencil-grey.svg";
import deleteIcon from "../../../images/icons/svg/trash-grey.svg";
import infoIcon from "../../../images/icons/svg/transparent-info.svg";

import { UikDivider } from "@uik";

import styles from "./DocumentTemplatesTable.module.scss";

export default (props) => {
  const {
    setSelectedTemplate,
    handleRenameTemplateModalOpen,
    handleDeleteTemplateModalOpen,
    setShowTemplatePreviewModal,
    selectedTemplate,
  } = props;

  const documentTemplates = useSelector((state) => {
    return state.documentTemplates;
  });

  useEffect(() => {
    if (selectedTemplate) {
      function selectTargetTemplate() {
        document.getElementById(selectedTemplate.id).focus();
      }

      const observer = new MutationObserver(function (
        mutations,
        mutationInstance
      ) {
        const targetTemplate = document.getElementById(selectedTemplate.id);
        if (targetTemplate) {
          selectTargetTemplate();
          mutationInstance.disconnect();
        }
      });

      observer.observe(document, {
        childList: true,
        subtree: true,
      });
    }
  }, []);

  // The blank files are offered as tiles above this table, so only the
  // library's own templates are listed here.
  const libraryTemplates = (documentTemplates || []).filter((template) => {
    return !template.global;
  });

  const renderTemplatesList = () => {
    if (libraryTemplates.length > 0) {
      return (
        <div className={styles.container}>
          <div className={styles.activityLogSubheadingContainer}>
            <div className={styles.activityLogSubheadingOne}>title</div>
          </div>
          <UikDivider />
          <div>
            <div>{generateTemplatesList()}</div>
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.emptyContainer}>
          <img className={styles.infoIcon} src={infoIcon} />
          <div className={styles.emptyStateText}>
            This library has no templates yet
          </div>
        </div>
      );
    }
  };

  const generateTemplatesList = () => {
    return libraryTemplates.map((template, index) => {
      const selected = selectedTemplate && selectedTemplate.id === template.id;

      return (
        <div
          id={template.id}
          onClick={() => {
            setSelectedTemplate(template);
          }}
          tabindex={index}
          className={
            (index === libraryTemplates.length - 1
              ? styles.lastTemplate
              : styles.templateDetails) +
            (selected ? " " + styles.selectedTemplate : "")
          }
        >
          <div className={styles.templateTitle}>{template.title}</div>
          <div className={styles.rightContainer}>
            <a
              onClick={() => {
                setShowTemplatePreviewModal(true);
              }}
              className={styles.previewLink}
            >
              Preview
            </a>
            <img
              onClick={(e) => {
                handleRenameTemplateModalOpen(e, template.title, template.id);
              }}
              src={editIcon}
              className={styles.editIcon}
            ></img>
            <img
              onClick={(e) => {
                handleDeleteTemplateModalOpen(e, template.title, template.id);
              }}
              className={styles.deleteIcon}
              src={deleteIcon}
            ></img>
          </div>
        </div>
      );
    });
  };

  return (
    <div className={styles.allContainer}>
      {renderTemplatesList()}
      {libraryTemplates.length > 3 && (
        <div className={styles.scrollIndicator}></div>
      )}
    </div>
  );
};
